
import type { PropOptions } from 'vue';
import Vue from 'vue';
import VideoIcon from './images/video.vue.svg';
import LinkedInIcon from './images/linkedin.vue.svg';
import type { IPost } from '@/types/community';
import { postTypes } from '~/components/partials/war-room/constants';

export default Vue.extend({
  name: 'WarRoomPostPreviewImage',
  components: {
    LinkedInIcon,
    VideoIcon,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    isYoutube(): boolean {
      return this.post.content.type === postTypes.YOUTUBE;
    },
    isLinkedin(): boolean {
      return this.post.content.type === postTypes.LINKEDIN;
    },
  },
});
